// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"393":"97d5a315","453":"68e2d313","984":"ab1f9f1f"}[chunkId] + ".chunk.js";
};